import { NO_KEY } from '../constants';
import { GregorioClefType } from '../enums/GregorioClefType';


export class GregorioClefInfo {
  line!: number;
  secondary_line!: number;
  pitch_difference!: number;
  clef!: GregorioClefType;
  flatted = false;
  secondary_clef!: GregorioClefType;
  secondary_flatted = false;

  /**********************************
   *
   * A function to build an integer from a key, very useful to represent
   * it in the structure.
   *
   *The representation is :
   *
   * * 1 for a C key on the first (bottom) line
   * * 3 for a C key on the second line
   * * 5 for a C key on the third line (default key)
   * * 7 for a C key on the fourth line
   * * 9 for a C key on the fifth line
   *
   * * -2 for a F key on the first line
   * * 0 for a F key on the second line
   * * 2 for a F key on the third line
   * * 4 for a F key on the fourth line
   * * 6 for a F key on the fifth line
   *
   *********************************/

  gregorio_calculate_new_key(): number {
    switch (this.clef) {
      case GregorioClefType.C:
        return (2 * this.line) - 1;
        break;
      case GregorioClefType.F:
        return (2 * this.line) - 4;
        break;
      default:
        /* not reachable unless there's a programming error */
        /* LCOV_EXCL_START */
        //  gregorio_fail(gregorio_calculate_new_key, "can't calculate key");
        return NO_KEY;
      /* LCOV_EXCL_STOP */
    }
  }

  static parse_clef_line(line: string): number {
      const resultLine = line.charCodeAt(0) - '0'.charCodeAt(0);
      if (resultLine < 0 || resultLine > 4) {
          // gregorio_messagef("parse_clef_line", VERBOSITY_ERROR, 0,
          //         _("invalid clef line for %u lines: %d"),
          //         (unsigned int)staff_lines, (int)line);
          return 1;
      }
      return resultLine;
  }

  static letter_to_clef(letter: string): GregorioClefType {
    switch (letter) {
      case 'c':
        return GregorioClefType.C;
      case 'f':
        return GregorioClefType.F;
    }
    /* not reachable unless there's a programming error */
    /* LCOV_EXCL_START */
    // gregorio_fail2(letter_to_clef, "invalid clef: %c", letter);
    return GregorioClefType.C;
  }
}
